import { Directive, ElementRef, HostBinding, Input, OnInit, Renderer2 } from '@angular/core';
import { SessionService } from '../session-service.service';
import { FontTypeEnum } from '../model/enums/FontTypeEnum';

@Directive({
  selector: '[appConfigSettingsButton]'
})
export class ConfigSettingsButtonDirective implements OnInit {

  FontTypeEnum = FontTypeEnum;
  backgroundDisabledColor = 'rgb(201, 201, 201)';

  constructor(private elementRef: ElementRef, private sessionService: SessionService) { }

  @Input()
  @HostBinding('attr.disabled') set disabled(disabled: boolean) {
    if (disabled) {
      this.elementRef.nativeElement.style.backgroundColor = this.backgroundDisabledColor;
    }
  }

  ngOnInit(): void {
    this.elementRef.nativeElement.style.color = this.sessionService.getConfigSettingsDto().fontColor;
    this.elementRef.nativeElement.style.fontFamily = FontTypeEnum[this.sessionService.getConfigSettingsDto().fontType] || FontTypeEnum.Sun;
  }
}
